import { routePaths } from "@/App";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export function TourSummarySkeleton() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  return (
    <div className="h-dvh flex flex-col">
      <div className="p-4 pt-14 bg-white space-y-2 pt-safe border-b-2 border-neutral">
        <header className="flex flex-col justify-center items-center mb-12">
          <Skeleton className="w-12 h-12 mb-6" />
          <Skeleton className="h-8 w-3/4 mb-2" />
        </header>

        <Skeleton className="h-12 w-full mb-4" />

        <div className="grid grid-cols-2 gap-4">
          {[...Array(4)].map((_, index) => (
            <Skeleton key={index} className="h-12 w-full" />
          ))}
        </div>
      </div>

      <div className="p-4 overflow-y-scroll space-y-4 flex-1 bg-list-background">
        <Skeleton className="h-16 w-full" />
        <Skeleton className="h-16 w-full" />
      </div>

      <footer className="p-4 bg-white border-t-2 border-neutral pb-safe ">
        <Button
          className="w-full"
          variant="secondary"
          onClick={() => {
            navigate(routePaths.home);
          }}
        >
          {t("tourSummary.button")}
        </Button>
      </footer>
    </div>
  );
}
